import { Spin } from 'antd';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { batch } from 'react-redux';
import { handleResponse } from '../../../Helper';
import { enrollmentApi } from '../../../api';
import { ResponseObjectEntity } from '../../../model/CommonModel';
import { CountersLabel, CountersValue, EnrollmentCounters } from '../../../model/EnrollmentModel';
import { useStoreDispatch, useStoreSelector } from '../../../store';
import { setUpdateFooterCount } from '../../../store/enrollment/actions';
import { selectUpdateFooterCounter } from '../../../store/enrollment/selectors';
import styles from './counterBar.module.scss';

type Props = {
	showCounterBar: boolean;
};

const CounterBar: React.FC<Props> = ({ showCounterBar }) => {
	const dispatch = useStoreDispatch();

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [countersValues, setCountersValues] = useState<CountersValue>({ AssignedCredentials: 0, GuestCredentials: 0, People: 0, UnassignedCredentials: 0 });
	const [countersLabels, setCountersLabels] = useState<CountersLabel>({
		UnassignedCredentials: _('UnassignedCredentials'),
		AssignedCredentials: _('AssignedCredentials'),
		GuestCredentials: _('GuestCredentials'),
		People: _('People'),
	});

	const updateFooterCounter: boolean = useStoreSelector<boolean>(selectUpdateFooterCounter);

	useEffect(() => {
		dispatch(setUpdateFooterCount(true));
	}, []);

	useEffect(() => {
		if (updateFooterCounter) {
			setIsLoading(true);

			enrollmentApi
				.getEnrollmentCounters()
				.then((response: ResponseObjectEntity<EnrollmentCounters>) => {
					if (!handleResponse(response)) {
						const { Labels, Values } = response.Entity;

						batch(() => {
							setCountersValues(Values);
							setCountersLabels(Labels);
						});
					}
				})
				.finally(() => {
					batch(() => {
						setIsLoading(false);
						dispatch(setUpdateFooterCount(false));
					});
				});
		}
	}, [updateFooterCounter]);

	const separator: JSX.Element = (
		<>
			<div />
			<span>|</span>
			<div />
		</>
	);

	const counterContent = (label: string, value: number): JSX.Element => (
		<>
			<strong>{label}</strong>
			<span>{value.toLocaleString()}</span>
		</>
	);

	return (
		<div className={cx(styles.container, { [styles.hideElement]: !showCounterBar })}>
			<Spin spinning={isLoading}>
				<div className={styles.content}>
					{counterContent(countersLabels.People, countersValues.People)}
					{separator}
					{counterContent(countersLabels.AssignedCredentials, countersValues.AssignedCredentials)}
					{separator}
					{counterContent(countersLabels.UnassignedCredentials, countersValues.UnassignedCredentials)}
					{separator}
					{counterContent(countersLabels.GuestCredentials, countersValues.GuestCredentials)}
				</div>
			</Spin>
		</div>
	);
};

export { CounterBar };
